import { getEnvironment, memoize, shallowMemoize } from '@sail/utils';
import { getTimeZoneData, supplemental } from '@stripe-internal/cldr';
import Globalize from 'globalize';
import { DEFAULT_LOCALE_DATA } from '../../internal/constants';
import { IntlUnsupportedTimeZoneError } from '../../internal/errors';
import handleGlobalizeError from '../../internal/errors/handleGlobalizeError/handleGlobalizeError';
import getLocaleData from '../../internal/getLocaleData';
const loadGlobalizeLocale = memoize((locale, reports)=>{
    try {
        // @ts-expect-error - TS2349 - This expression is not callable.
        return Globalize(locale);
    } catch (error) {
        handleGlobalizeError(error, reports);
    }
});
const loadGlobalizeTimeZone = memoize((timeZone, reports)=>{
    const zoneData = getTimeZoneData(timeZone);
    if (!zoneData) {
        const error = new IntlUnsupportedTimeZoneError(timeZone);
        reports.error(error, {
            project: 'sail_core'
        });
        if (getEnvironment() !== 'production') {
            throw error;
        }
        return;
    }
    Globalize.loadTimeZone(zoneData);
});
function feedGlobalize(cldr, reports) {
    cldr.forEach((data)=>{
        try {
            data && Globalize.load(data);
        } catch (error) {
            handleGlobalizeError(error, reports);
        }
    });
}
function feedGlobalizeWithDefaults(reports) {
    feedGlobalize(Object.values(supplemental), reports);
    feedGlobalize(Object.values(DEFAULT_LOCALE_DATA.cldr), reports);
}
const createGlobalizeWithLocale = shallowMemoize((config, requestedLocale, requestedTimeZone, reports)=>{
    const localeData = getLocaleData(requestedLocale, config, reports);
    requestedTimeZone && loadGlobalizeTimeZone(requestedTimeZone, reports);
    feedGlobalizeWithDefaults(reports);
    localeData.cldr && feedGlobalize(Object.values(localeData.cldr), reports);
    const globalizeWithLocale = loadGlobalizeLocale(localeData.locale, reports);
    return globalizeWithLocale;
});
export default createGlobalizeWithLocale;

//# sourceMappingURL=createGlobalizeWithLocale.js.map